import { Link, useNavigate } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { FadeUp } from "@/components/motion";
import { scrollToId } from "@/components/Navbar";
import { useContent } from "@/lib/content";

export default function Footer() {
  const c = useContent();
  const navigate = useNavigate();
  const go = (href) => {
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(href), 400);
    } else scrollToId(href);
  };
  return (
    <footer id="kontakt" className="bg-forest-dark text-sand grain relative" data-testid="footer-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <FadeUp className="lg:col-span-5">
            <img
              src="/logo.png"
              alt="Hotel Wildpferd Dülmen"
              className="h-24 w-auto rounded-2xl bg-sand p-2 shadow-lg shadow-black/30"
            />
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Dülmen · Münsterland</p>
            <p className="mt-6 text-sm text-sand/70 leading-relaxed max-w-sm">
              {c.footer_about}
            </p>
            <Link
              to="/buchen"
              data-testid="footer-book-button"
              className="mt-8 inline-block rounded-full bg-gold text-forest-dark px-7 py-3 text-sm font-bold hover:bg-sand transition-colors duration-300"
            >
              Jetzt Zimmer buchen
            </Link>
          </FadeUp>

          <FadeUp delay={0.1} className="lg:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-sand/50">Kontakt</p>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-gold shrink-0" />
                <span>{c.contact_address_1}<br />{c.contact_address_2}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-gold shrink-0" />
                <a href={`tel:${c.contact_phone_link}`} className="hover:text-gold transition-colors" data-testid="footer-phone">{c.contact_phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-gold shrink-0" />
                <a href={`mailto:${c.contact_email}`} className="hover:text-gold transition-colors" data-testid="footer-email">{c.contact_email}</a>
              </li>
            </ul>
          </FadeUp>

          <FadeUp delay={0.2} className="lg:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-sand/50">Check-in & Service</p>
            <ul className="mt-5 space-y-2 text-sm text-sand/80">
              {c.service_lines.map((line) => <li key={line}>{line}</li>)}
            </ul>
            <div className="mt-8 flex flex-wrap gap-5 text-sm">
              <button onClick={() => go("#hotel")} className="hover:text-gold transition-colors" data-testid="footer-link-hotel">Das Hotel</button>
              <button onClick={() => go("#zimmer")} className="hover:text-gold transition-colors" data-testid="footer-link-zimmer">Zimmer</button>
              <button onClick={() => go("#faq")} className="hover:text-gold transition-colors" data-testid="footer-link-faq">FAQ</button>
              <Link to="/admin/login" className="hover:text-gold transition-colors" data-testid="footer-admin-link">Admin-Bereich</Link>
            </div>
          </FadeUp>
        </div>

        <div className="mt-16 pt-8 border-t border-sand/15 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-sand/50">
          <p>© {new Date().getFullYear()} Hotel Wildpferd Dülmen. Alle Rechte vorbehalten.</p>
          <div className="flex gap-6">
            <Link to="/impressum" className="hover:text-sand transition-colors" data-testid="footer-link-impressum">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-sand transition-colors" data-testid="footer-link-datenschutz">Datenschutz</Link>
            <Link to="/agb" className="hover:text-sand transition-colors" data-testid="footer-link-agb">AGB</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
